import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  View,
  Text,
  ImageBackground,
  SafeAreaView,
  StyleSheet,
  TouchableOpacity,
  Image,
  Platform,
  Modal,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import Colors from "../../Theme/Colors";
import { typo } from "../../Theme/Typo";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import { TextInput } from "react-native-paper";
import Button from "../Button";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { AntDesign, Feather, Fontisto, Ionicons } from "@expo/vector-icons";
import Entypo from "@expo/vector-icons/Entypo";

import * as ImagePicker from "expo-image-picker";
import ImageViewer from "react-native-image-zoom-viewer";
import Mutation from "../../api/mutation";
import LoadingModal from "../LoadingModal";
import RootStore from "../../Store";

import Queries from "../../api/queries";
import { Picker } from "@react-native-picker/picker";
import DatePicker from "react-native-modern-datepicker";
import { format, set } from "date-fns";
import CameraScreen from "../CameraScreen";
import ModalQLerr from "../../utils/ModalQLerr";
import AlertCustom from "../utils/alert";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const { userInfo } = RootStore.getInstance();

interface AppartInfos {
  appartId: string;
  oiqiaLabel: string;
}

interface AchatsType {
  _id: string;
  totalPriceTTC: number;
  creationDate: string;
  url: string;
}

export const Achats = () => {
  const { t } = useTranslation();

  const mutation = new Mutation();
  const queries = new Queries();

  // Permissions
  const [MediaAvailable, setMediaAvailable] = useState(false);

  const [QLerror, setQLerror] = useState("");

  // Form
  const [appartId, setAppartId] = useState<string>("");
  const [pictures, setPictures] = useState<Array<any>>([]);
  const [totalPriceTTC, setTotalPriceTTC] = useState<string>("");
  const [purchaseDate, setPurchaseDate] = useState<string>(
    format(new Date(), "yyyy/MM/dd")
  );

  // Form errors
  const [priceError, setPriceError] = useState<boolean>(false);

  const [cameraOpen, setCameraOpen] = useState(false);

  // Old achats
  const [achats, setAchats] = useState<Array<AchatsType>>();

  // Else
  const [isLoading, setLoading] = useState<boolean>(false);
  const [appartList, setAppartList] = useState<Array<AppartInfos>>();
  const [isViewer, setViewer] = useState({
    isVisible: false,
    index: 0,
  });
  const [changingDate, setChangingDate] = useState(false);

  const [isViewerTicket, setViewerTicket] = useState({
    isVisible: false,
    index: 0,
    url: [],
  });

  useEffect(() => {
    (async () => {
      // Pictures library permission
      const { granted: mediaGranted = false } =
        await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (mediaGranted) {
        setMediaAvailable(true);
      } else {
        AlertCustom(
          t("TITLE_MSG_PERMISSION_DENIED"),
          t("MSG_PERMISSION_MEDIA_DENIED")
        );
      }

      try {
        const responseGQL = await queries.getPrestaAppart();
        // cleaning doubles
        setAppartList(responseGQL.data.getPrestaAppart.appartements);

        if (
          responseGQL.data.getPrestaAppart.appartements &&
          responseGQL.data.getPrestaAppart.appartements.length > 0
        ) {
          setAppartId(
            responseGQL.data.getPrestaAppart.appartements[0].appartId
          );
        }

        await getAchatsList();
      } catch (err) {
        setQLerror(err);
      }
    })();
  }, []);

  const getAchatsList = async () => {
    setLoading(true);

    try {
      const responseQL = await queries.getLastPrestaConsummableNew();

      let errors = responseQL?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const achatFetched = responseQL.data.getPrestaConsummableNew.achats;

        for (let achat of achatFetched) {
          const { url } = achat;
          let array = [];
          for (let src of url) {
            array.push({ url: src });
          }
          achat.url = array;
        }

        setAchats(achatFetched);
      }
    } catch (err) {
      setQLerror(err);
      setLoading(false);
    }

    setLoading(false);
  };

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: false,
      base64: true,
      quality: 0.5,
    });
    if (!result.cancelled) {
      setLoading(true);
      addPicture(result);
    }
    setLoading(false);
  };

  const addPicture = (picture: object) => {
    const temp = [...pictures];
    if(picture?.assets?.[0]) temp.push({ uri: picture.assets?.[0].uri, base64: picture.assets?.[0].base64 });
    //console.log("temp", temp);
    setPictures(temp);
  };

  const deletePicture = (index: any) => {
    AlertCustom(
      t("RERMOVE_ACHAT_CONFIRM_TITLE"),
      t("RERMOVE_PICTURE_CONFIRM_BODY"),
      [
        // The "Yes" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_YES"),
          onPress: () => {
            const temp = [...pictures];
            temp.splice(index, 1);
            setPictures(temp);
          },
        },
        // The "No" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_FALSE"),
        },
      ]
    );
  };

  const popExplanations = () => {
    AlertCustom(t("ACHATS_EXPLANATIONS"), t("ACHATS_EXPLANATIONS_TEXT"));
  };

  const popAchatListExplanation = () => {
    AlertCustom(t("ACHATS_TITLE_LIST"), t("ACHATS_LIST_EXPLANATION_BODY"));
  };

  const changeDate = () => {
    changingDate ? setChangingDate(false) : setChangingDate(true);
  };

  const removeAchatDeclaration = async (achatID: string): Promise<void> => {
    AlertCustom(
      t("RERMOVE_ACHAT_CONFIRM_TITLE"),
      t("RERMOVE_ACHAT_CONFIRM_BODY"),
      [
        // The "Yes" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_YES"),
          onPress: async () => {
            setLoading(true);
            try {
              await mutation.removeAchatDeclaration(
                achatID,
                userInfo.getToken()
              );
              await getAchatsList();
            } catch (err) {
              setQLerror(err);
            }
            setLoading(false);
          },
        },
        // The "No" button
        {
          text: t("RERMOVE_ACHAT_CONFIRM_FALSE"),
        },
      ]
    );
  };

  const displayDate = () => {
    const getMonth = (numberMonth: string) => {
      let res = "";

      switch (numberMonth) {
        case "01":
          res = "Janvier";
          break;
        case "02":
          res = "Février";
          break;
        case "03":
          res = "Mars";
          break;
        case "04":
          res = "Avril";
          break;
        case "05":
          res = "Mai";
          break;
        case "06":
          res = "Juin";
          break;
        case "07":
          res = "Juillet";
          break;
        case "08":
          res = "Août";
          break;
        case "09":
          res = "Septembre";
          break;
        case "10":
          res = "Octobre";
          break;
        case "11":
          res = "Novembre";
          break;
        case "12":
          res = "Décembre";
          break;
      }

      return res;
    };

    return `${purchaseDate.substring(8, 10)} ${getMonth(
      purchaseDate.substring(5, 7)
    )} ${purchaseDate.substring(0, 4)}`;
  };

  const addConsumables = async () => {
    setPriceError(false);

    setLoading(true);
    if (!totalPriceTTC) {
      setPriceError(true);
    }
    if (isNaN(parseFloat(totalPriceTTC))) {
      setPriceError(true);
    }
    if (pictures.length == 0) {
      alert(t("ACHAT_PROOF_MISSING"));
    }

    if (!isNaN(parseFloat(totalPriceTTC)) && pictures.length > 0) {
      const dateGQL = set(new Date(), {
        year: Number(purchaseDate.substring(0, 4)),
        month: Number(purchaseDate.substring(5, 7)) - 1,
        date: Number(purchaseDate.substring(8, 10)),
        hours: 12,
        minutes: 0,
      });

      try {
        const newTotalPriceTTC = totalPriceTTC.split(",").join(".");
        await mutation.addConsumablePresta(
          parseFloat(newTotalPriceTTC),
          dateGQL,
          pictures.map((picture) =>
            picture.base64 ? picture.base64 : picture.uri
          ),
          userInfo.getToken(),
          appartId
        );

        // ! REDIRECT
        setTotalPriceTTC("");
        setPictures([]);
        await getAchatsList();
      } catch (err) {
        //console.log(JSON.stringify(err, null, 2));
        setQLerror(err);
      }
      setLoading(false);
    } else {
      AlertCustom(t("ACHAT_WRONG_PARAM_TITLE"), t("ACHAT_WRONG_PARAM_BODY"));
    }
    setLoading(false);
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView>
          <Modal
            visible={cameraOpen}
            onRequestClose={() => setCameraOpen(false)}
          >
            <CameraScreen
              closeCamera={() => setCameraOpen(false)}
              isChat={false}
              pictures={pictures}
              setPictures={setPictures}
            />
          </Modal>
          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}
          <View style={typo.container}>
            <Text style={typo.titleInfo}>Achats & Fournitures</Text>
            {isLoading && <LoadingModal loading={isLoading} />}

            {appartList && appartList.length > 0 && (
              <View style={typo.resCard}>
                <View style={typo.underlineCat}>
                  <MaterialIcons
                    name="add-shopping-cart"
                    size={25}
                    style={{ marginRight: 10 }}
                    color={Colors.oiqia}
                    onPress={() => popExplanations()}
                  />
                  <Text style={typo.category}>{t("ACHATS_TITLE_DECLARE")}</Text>
                </View>

                <View>
                  <Text
                    style={{
                      fontWeight: "500",
                      marginBottom: 10,
                      color: Colors.black,
                    }}
                  >
                    {t("APPART_SELECTION_TITLE")}
                  </Text>
                  {appartList && appartList.length == 1 && (
                    <Text
                      style={{
                        textAlign: "center",
                        color: Colors.oiqia,
                        marginBottom: 10,
                        fontSize: 24,
                      }}
                    >
                      <MaterialIcons
                        name="location-city"
                        size={18}
                        color={Colors.oiqia}
                      ></MaterialIcons>
                      {appartList[0].oiqiaLabel}
                    </Text>
                  )}
                  {appartList && appartList.length > 1 && (
                    <Picker
                      selectedValue={appartId}
                      onValueChange={(itemValue: string) =>
                        setAppartId(itemValue)
                      }
                    >
                      {appartList?.map((value, index) => {
                        return (
                          <Picker.Item
                            key={index}
                            label={value.oiqiaLabel}
                            value={value.appartId}
                          />
                        );
                      })}
                    </Picker>
                  )}
                  <Text style={{ fontWeight: "500", color: Colors.black }}>
                    {t("PRICE_INPUT_TITLE")}
                  </Text>

                  <TextInput
                    activeOutlineColor={Colors.oiqia}
                    label={t("ACHAT_PRODUCT_TITLE_TTC")}
                    keyboardType={"numeric"}
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "white",
                    }}
                    mode="outlined"
                    value={totalPriceTTC}
                    onChangeText={(e: string) => {
                      setPriceError(false);
                      setTotalPriceTTC(e);
                    }}
                    error={priceError}
                  />

                  <View>
                    <Text
                      style={{
                        fontWeight: "500",
                        marginBottom: 10,
                        color: Colors.black,
                      }}
                    >
                      {t("PURCHASE_DATE_TITLE")}
                    </Text>
                    {changingDate == true && (
                      <DatePicker
                        onSelectedChange={(date: string) =>
                          setPurchaseDate(date)
                        }
                        mode={"calendar"}
                        options={{
                          textHeaderColor: Colors.oiqia,
                          textDefaultColor: Colors.oiqia,
                          selectedTextColor: Colors.white,
                          mainColor: Colors.oiqia,
                          textSecondaryColor: Colors.oiqia,
                        }}
                      />
                    )}
                    <Button
                      text={changingDate ? "Valider" : `${displayDate()}`}
                      onPress={() => changeDate()}
                      style={{
                        backgroundColor: Colors.oiqia,
                        marginBottom: 10,
                      }}
                    ></Button>
                  </View>

                  <Text style={[styles.infos, { marginBottom: 10 }]}>
                    {t("ACHATS_PICTURE_TITLE")}
                  </Text>
                  <View style={typo.catCard}>
                    {pictures.length > 0 ? (
                      <ScrollView horizontal>
                        {pictures.map((element, index) => (
                          <View key={index} style={{ margin: 5 }}>
                            <TouchableOpacity
                              onPress={() =>
                                setViewer({ isVisible: true, index })
                              }
                            >
                              <Image
                                style={styles.image}
                                source={{ uri: element.uri }}
                              />
                            </TouchableOpacity>
                            <View style={{ alignSelf: "center" }}>
                              <FontAwesome
                                name="trash"
                                size={24}
                                color={Colors.red}
                                onPress={() => deletePicture(index)}
                              />
                            </View>
                          </View>
                        ))}
                      </ScrollView>
                    ) : (
                      <View style={{ alignSelf: "center" }}>
                        <Text style={typo.body}>
                          {t("PROBLEM_PICTURES_EMPTY")}
                        </Text>
                      </View>
                    )}
                  </View>
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      marginTop: 10,
                      alignItems: "center",
                      marginBottom: 30,
                    }}
                  >
                    <TouchableOpacity
                      style={styles.colImg}
                      onPress={() => setCameraOpen(true)}
                    >
                      <AntDesign name="camera" size={30} color={Colors.oiqia} />
                      <Text>{t("PROBLEM_PICTURE_TAKE")}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.colImg}
                      disabled={!MediaAvailable}
                      onPress={() => pickImage()}
                    >
                      <AntDesign
                        name="picture"
                        size={30}
                        color={MediaAvailable ? Colors.oiqia : Colors.black}
                      />
                      <Text>{t("PROBLEM_PICTURE_PICK")}</Text>
                    </TouchableOpacity>
                  </View>
                  {!MediaAvailable && (
                    <View style={typo.resCard}>
                      <Text style={styles.cautionMessage}>
                        Vous n'avez pas autorisé l'application à accéder à votre
                        galerie photo
                      </Text>
                      <Text style={styles.cautionMessage}>
                        {"\n"}Vous pouvez changer ces paramètres via les
                        réglages de votre appareil
                      </Text>
                    </View>
                  )}
                </View>

                {Platform.OS != "web" && pictures.length > 0 && (
                  <SafeAreaView style={{ flex: 1 }}>
                    <Modal visible={isViewer.isVisible} transparent={true}>
                      <ImageViewer
                        key={isViewer.index}
                        enableSwipeDown={true}
                        index={isViewer.index}
                        imageUrls={pictures.map((ele) => {
                          return {
                            url: ele.uri,
                            props: { source: ele.uri },
                          };
                        })}
                        renderHeader={() => (
                          <SafeAreaView>
                            <TouchableOpacity
                              onPress={() =>
                                setViewer({ isVisible: false, index: 0 })
                              }
                            >
                              <Entypo
                                name="cross"
                                onPress={() =>
                                  setViewer({ isVisible: false, index: 0 })
                                }
                                size={60}
                                color="white"
                              />
                            </TouchableOpacity>
                          </SafeAreaView>
                        )}
                      ></ImageViewer>
                    </Modal>
                  </SafeAreaView>
                )}
                <View>
                  <Button
                    style={{
                      alignSelf: "center",
                      backgroundColor: Colors.oiqia,
                    }}
                    text={t("ACHAT_PRODUCT_CONFIRM")}
                    onPress={() => addConsumables()}
                  />
                </View>
              </View>
            )}
            {appartList && appartList.length == 0 && (
              <View style={typo.resCard}>
                <Text style={{ color: Colors.red, fontStyle: "italic" }}>
                  {t("ACHATS_NO_APPART_LINKED")}
                </Text>
              </View>
            )}
            <View style={typo.resCard}>
              <View style={styles.achatTitles}>
                <Feather
                  name="list"
                  style={{ marginRight: 10 }}
                  size={24}
                  color={Colors.oiqia}
                  onPress={() => popAchatListExplanation()}
                />
                <View style={styles.column}>
                  <View style={styles.titleLeft}>
                    <Text style={typo.category}>{t("ACHATS_TITLE_LIST")}</Text>
                  </View>
                  <View style={styles.titleRight}>
                    <Text
                      onPress={async () => await getAchatsList()}
                      style={{ color: Colors.oiqia, textAlign: "right" }}
                    >
                      <Ionicons
                        name="refresh-outline"
                        size={24}
                        color={Colors.oiqia}
                      />
                    </Text>
                  </View>
                </View>
              </View>
              {achats?.map((achat) => {
                return (
                  <View key={achat._id} style={typo.resCard}>
                    <View style={typo.underlineCat}>
                      <View>
                        <Text style={styles.achatTextDate}>
                          <Fontisto
                            name="date"
                            size={20}
                            color={Colors.black}
                          />{" "}
                          {achat.purchaseDateString}
                        </Text>
                      </View>
                    </View>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <View style={{}}>
                        <View>
                          <Text style={styles.achatTextPrice}>
                            {t("ACHAT_TOTAL_PRICE_TTC")}{" "}
                            <Text style={{ color: Colors.oiqia }}>
                              {achat.totalPriceTTC}€
                            </Text>{" "}
                          </Text>
                        </View>
                        <View>
                          <Text
                            onPress={() =>
                              setViewerTicket({
                                isVisible: true,
                                index: 0,
                                url: achat.url,
                              })
                            }
                            style={{
                              color: Colors.oiqia,
                              textDecorationLine: "underline",
                            }}
                          >
                            {t("ACHAT_SEE_BILL")}
                          </Text>
                        </View>
                      </View>
                      <View style={{}}>
                        <Text>
                          <FontAwesome
                            name="trash-o"
                            size={24}
                            color={Colors.red}
                            onPress={() => removeAchatDeclaration(achat._id)}
                          />
                        </Text>
                      </View>
                    </View>

                    {Platform.OS != "web" && achat.url && (
                      <SafeAreaView style={{ flex: 1 }}>
                        <Modal
                          visible={isViewerTicket.isVisible}
                          transparent={true}
                        >
                          <ImageViewer
                            /* index={isViewerTicket.index} */
                            imageUrls={isViewerTicket.url}
                            renderHeader={() => (
                              <SafeAreaView>
                                <TouchableOpacity
                                  onPress={() =>
                                    setViewerTicket({
                                      isVisible: false,
                                      index: 0,
                                      url: [],
                                    })
                                  }
                                >
                                  <Entypo
                                    name="cross"
                                    onPress={() =>
                                      setViewerTicket({
                                        isVisible: false,
                                        index: 0,
                                        url: [],
                                      })
                                    }
                                    size={60}
                                    color="white"
                                  />
                                </TouchableOpacity>
                              </SafeAreaView>
                            )}
                          ></ImageViewer>
                        </Modal>
                      </SafeAreaView>
                    )}
                  </View>
                );
              })}
            </View>
          </View>
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  achatsBox: {
    marginBottom: 10,
    display: "flex",
  },

  achatTitles: {
    alignItems: "center",
    textAlign: "center",
    flexDirection: "row",
    paddingBottom: 5,
    marginBottom: 10,
  },

  titleLeft: {
    justifyContent: "flex-start",
  },

  titleRight: {
    justifyContent: "flex-end",
  },

  linkInfo: {
    width: "50%",
    textAlign: "left",
    justifyContent: "flex-start",
  },

  achatInfoLeft: {
    color: Colors.oiqia,
    textAlignVertical: "center",
    textAlign: "center",
  },

  achatInfoRight: {
    color: Colors.black,
    marginVertical: 5,
  },

  achatTextDate: {
    fontSize: 20,
    color: Colors.oiqia,
    textAlignVertical: "center",
    textAlign: "center",
  },

  achatTextPrice: {
    color: Colors.black,
  },

  infos: {
    color: Colors.oiqia,
    fontStyle: "italic",
  },

  colImg: {
    alignItems: "center",
    marginBottom: -10,
  },

  userInfo: {
    textTransform: "capitalize",
  },

  invoiceBox: {
    marginBottom: 20,
  },

  link: {
    backgroundColor: "#d71d9a",
    color: "white",
    textAlign: "center",
    marginTop: 10,
    borderColor: "#d71d9a",
    borderStyle: "solid",
    borderWidth: 5,
    paddingVertical: 5,
    borderRadius: 20,
  },

  flex: {
    display: "flex",
  },

  imageWrapper: {
    justifyContent: "center",
    alignItems: "center",
  },

  codeWrap: {
    flex: 1,
    alignSelf: "flex-start",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  code: {
    fontSize: 22,
    color: Colors.oiqia,
    borderColor: "#0A0A0AE7",
    borderWidth: 0.5,
    borderRadius: 5,
    letterSpacing: 2,
    padding: 5,
    margin: 10,
    fontFamily: "RobotoBold",
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },

  invoiceInfo: {
    width: "50%",
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  underlineDot: {
    borderColor: "#0A0A0AE7",
    borderStyle: "dashed",
    borderRadius: 1,
    borderBottomWidth: 1,
    paddingBottom: 10,
    marginBottom: 10,
  },

  wrap10: {
    margin: 15,
  },
  button: {
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: Colors.oiqia,
  },
  box: {
    marginVertical: 10,
  },
  title: {
    fontSize: 26,
    color: "white",
    textAlign: "center",
    /*     alignItems: "center", */
    /*     justifyContent: "center", */
    marginBottom: 20,
    fontFamily: "OpenSansSemiBold",
  },
  subTitle: {
    fontSize: 15,
    fontWeight: "bold",
    //fontWeight: "700",
    color: "#000030",
    margin: 5,
  },
  subTitleBis: {
    fontSize: 15,
    fontWeight: "bold",
    //fontWeight: "700",
    color: "#808080",
    marginLeft: 5,
    //margin: 5,
  },
  image: {
    left: 5,
    top: 5,
    width: 200,
    height: 150,
    borderWidth: 1,
    borderRadius: 1,
    marginRight: 10,
    borderColor: "white",
    marginBottom: 5,
  },
  buttonWrapper: {
    width: "90%",
    alignSelf: "center",
    borderRadius: 10,
  },
  tinyLogo: {
    width: 166,
    height: 143,
  },

  imageCard: {
    resizeMode: "contain",
    borderColor: "grey",
    borderWidth: 2,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
  },

  accesCodeText: {
    textAlign: "center",
    paddingLeft: 0,
  },

  adressCard: {
    padding: 15,
    width: "100%",
    borderColor: "#eae8e1",
    borderWidth: 4,
    borderRadius: 20,
    marginBottom: 30,
  },
  attachmentTitles: {
    left: 5,
    marginBottom: 5,
    fontSize: 17,
    fontWeight: "bold",
  },
  centeredView: {
    flex: 2,
    justifyContent: "center",
    alignItems: "center",
  },
  cautionMessage: {
    color: "red",
  },
});

export default Achats;
